import React, { Component } from 'react';

class AppInfo extends Component {
    constructor(props) {
        super(props);
    }
    // Render method
    render() {

        return (
            <div className="app_version">
                ver. 2.13
            </div>
        );
    }
}

export default AppInfo;
